import {useNavigate, useSearchParams} from "react-router-dom";
import {serviceTypeSelector, useGetServiceTypeQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {ServiceTypeProfile} from "../../components/profile/ServiceTypeProfile/ServiceTypeProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const ServiceTypeProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.servicetype", "Service Type") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ServiceTypeProfilePage id={id}/>;
};

export const ServiceTypeProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectServiceType = useMemo(() => {
    return serviceTypeSelector()
  }, []);

  const {serviceType, isFetching} = useGetServiceTypeQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      serviceType: selectServiceType(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      permissions={["servicetype_view"]}
      entity={serviceType}
      isLoading={isFetching}
      onAccess={setAccess}>
      {(entity) => (
        <ServiceTypeProfile serviceType={entity}/>
      )}
    </EntityProfilePage>
  )
};
